import React from 'react'
import { useDispatch } from 'react-redux'
import { selectSubSportType } from '../LiveSlice'
import { SubSports } from '../types'
import styles from './SubSportTypes.module.css'

interface Props {
  sports: SubSports[]
  currentSport: string
  currentSubSport: string | null
}

const SubSportTypes = ({ sports, currentSport, currentSubSport }: Props) => {
  const dispatch = useDispatch()
  const subSportTypeClick = (subSportTypeId: string) => {
    dispatch(selectSubSportType({ subSportTypeId }))
    //dispatch(fetchLiveChampionships())
  }

  return (
    <div className={styles.subSportTypes}>
      {sports.map((sport: SubSports) => (
        <div key={sport.Id}
          onClick={() => subSportTypeClick(sport.Id)}
          className={`${styles.subSportTypeIcon} ${
            sport.Id === currentSubSport ? styles.active : ''
          }`}
        >
          <span className={`MobSportType${sport.Id} ${styles['MobSportType'+sport.Id]}`}></span>
        </div>
      ))}
    </div>
  )
}

export default SubSportTypes